module.exports = "/images/loading.gif?2d65891bc8e66140a625961100dee199";